export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidPassword(password) {
  return password && password.length >= 8;
}

export function isValidPhone(phone) {
  if (!phone) return true; // optional
  return /^[\d\s\-+()]{7,20}$/.test(phone);
}

export function required(value, fieldName = 'This field') {
  if (!value || !String(value).trim()) {
    return `${fieldName} is required`;
  }
  return null;
}
